package com.tovtalk.domain.usecase.post

import com.tovtalk.domain.entity.DomainResult
import com.tovtalk.domain.repository.PostRepository

/**
 * Like/Unlike Post Use Case (v2)
 */
class LikePostUseCase(
    private val postRepository: PostRepository
) {
    suspend operator fun invoke(postId: Int, isLiked: Boolean): DomainResult<Unit> {
        return if (isLiked) {
            postRepository.unlikePost(postId)
        } else {
            postRepository.likePost(postId)
        }
    }
}
